export const NxSideNavAccordionConfig = {
    serviceInstance: new Object()
};
